import DurationFormat from './DurationFormat';

export default DurationFormat;
